import axios from 'axios';

const apiClient = axios.create({
  baseURL: (process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001') + '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const login = (credentials) =>
  apiClient.post('/auth/login', credentials);

export const register = (userData) =>
  apiClient.post('/auth/register', userData);

// Stores
export const getStores = () =>
  apiClient.get('/stores');

export const getStore = (storeId) =>
  apiClient.get(`/stores/${storeId}`);

export const createStore = (storeData) =>
  apiClient.post('/stores', storeData);

// Menu
export const getMenu = (storeId) =>
  apiClient.get(`/menu?store_id=${storeId}`);

export const createMenuItem = (menuData) =>
  apiClient.post('/menu', menuData);

// Customers
export const lookupCustomer = (storeId, phone) =>
  apiClient.get(`/customers/lookup?store_id=${storeId}&phone=${phone}`);

export const createCustomer = (customerData) =>
  apiClient.post('/customers', customerData);

export const updateCustomer = (customerId, customerData) =>
  apiClient.put(`/customers/${customerId}`, customerData);

// Orders
export const createOrder = (orderData) =>
  apiClient.post('/orders', orderData);

export const getOrders = (storeId, status = null, limit = 100) => {
  const params = new URLSearchParams({ store_id: storeId, limit });
  if (status) params.append('status', status);
  return apiClient.get(`/orders?${params.toString()}`);
};

export const getOrder = (orderId) => 
  apiClient.get(`/orders/${orderId}`);

export const updateOrderStatus = (orderId, status) => 
  apiClient.put(`/orders/${orderId}/status`, { status });

export const assignRider = (orderId, riderId, riderName) => {
  const url = `/orders/${orderId}/assign-rider?rider_id=${encodeURIComponent(riderId)}&rider_name=${encodeURIComponent(riderName)}`;
  return apiClient.put(url);
};

export const cancelOrder = (orderId, cancelData) =>
  apiClient.put(`/orders/${orderId}/cancel`, cancelData);

export const markOrderServed = (orderId) =>
  apiClient.put(`/orders/${orderId}/mark-served`);

export const markOrderPickedUp = (orderId) =>
  apiClient.put(`/orders/${orderId}/mark-picked-up`);

export const getCompletedOrders = (storeId) =>
  apiClient.get(`/orders/completed?store_id=${storeId}`);

// Payments
export const createPayment = (paymentData) =>
  apiClient.post('/payments', paymentData);

// Devices
export const registerDevice = (deviceData) =>
  apiClient.post('/devices/register', deviceData);

export const loginDevice = (deviceKey) =>
  apiClient.post('/devices/login', { device_key: deviceKey });

// Riders
export const getActiveRiders = (storeId) =>
  apiClient.get(`/riders/active?store_id=${storeId}`);

export const markRiderOnline = () =>
  apiClient.post('/riders/online');

export const markRiderOffline = () =>
  apiClient.post('/riders/offline');

export default apiClient;
